import { useMemo } from "react";
import { useWindowSize } from "../../../hooks/useWindowSize"
import { TabsViewer } from "../../../utils/TabsViewer";
import { LocationsGIS } from "../../../components/LocationsGIS";
import OpGroupDTO from "@common/dtos/OpGroupDTO";
import { useTranslation } from "react-i18next";
import { LocationsList } from "./LocationsList";
import { LogViewer } from "../../../components/LogViewer";

export interface TabsLayoutProps {
    group: OpGroupDTO;
}

export default function TabsLayout({ group }: TabsLayoutProps){
    const { t } = useTranslation();
    const { innerWidth } = useWindowSize();
    const mobile = useMemo(() => innerWidth < 1000, [innerWidth]);

    const LocationsListSection = useMemo(() => <LocationsList locations={group.locations || []} />, [group.locations]);

    if (mobile) return (
        <TabsViewer
            id={'group'}
            defaultTab={'locations'}
            tabs={[
                {
                    name: 'geo', title: t('geo'), icon: 'fas fa-globe', disableSwipe: true,
                    component: (
                        <div className="d-flex flex-column w-100 h-100 align-items-center">
                            <LocationsGIS locations={group.locations || []}/>
                            <button className="btn btn-primary mb-1 mt-1 position-absolute d-flex align-items-center justify-content-center" style={{width: 250}} onClick={() => {
                                const el = document.querySelector<HTMLElement>('#locations-link.nav-link');
                                if (el) el.click();
                            }}><span>{t('back_to_locations_list')}</span><i className="fas fa-arrow-right-long fa-xl position-absolute" style={{right: 8}}/> </button>
                        </div>
                    )
                },
                {
                    name: 'locations', title: t('locations'), icon: 'fas fa-map-marker-alt',
                    component: LocationsListSection
                },
                {
                    name: 'logs', title: t('logs'), icon: 'fas fa-bell',
                    component: <LogViewer groupId={group.id}/>
                }
            ]}
        />
    );
    
    return (
        <div className="d-flex flex-row w-100 flex-fill overflow-hidden">
            <div className="d-flex flex-column align-items-center col-8">
                <TabsViewer
                    id={'group'}
                    defaultTab={'locations'}
                    tabs={[
                        {
                            name: 'geo', title: t('geo'), icon: 'fas fa-globe', disableSwipe: true,
                            component: <LocationsGIS locations={group.locations || []}/>
                        },
                        {
                            name: 'locations', title: t('locations'), icon: 'fas fa-map-marker-alt',
                            component: LocationsListSection
                        }
                    ]}
                />
            </div>
            <div className="d-flex flex-column flex-fill col-4">
                <div className="d-flex flex-column flex-fill overflow-auto pe-2">
                    <LogViewer groupId={group.id}/>
                </div>
                
            </div>
            
        </div>
    )
}